import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BodyText from 'components/widget/BodyText';
import Button from 'components/Button';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';
import moment from 'moment';
import WidgetContainer from 'components/widget/WidgetContainer';
import getBoxSizeString from 'components/helpers/getBoxSizeString';
import ProductImageView from 'components/ProductImageView';
import { FullWidthPaperContent } from 'components/Paper';

const StyledOrderSkipView = styled(FullWidthPageContent)`
  .topSection {
    padding: ${({ theme }) => theme.spacing * 2}px;
  }

  .formCta {
    padding: ${({ theme }) => theme.spacing * 2}px;
    > * {
      margin-bottom: ${({ theme }) => theme.spacing * 2}px;
    }
  }
`;

const OrderSkipView = ({
  className, pack, onSkip, onCancel,
}) => {
  const classes = ['OrderSkipView', className];

  return (
    <StyledOrderSkipView className={classes.filter((c) => !!c).join(' ')}>
      <div className="topSection">
        <h1 className="no_margin_top">Skip delivery</h1>
        <BodyText>
          Please confirm you&apos;d like to skip this delivery.
        </BodyText>
      </div>

      <WidgetContainer
        noRoundedCorners
      >
        <FullWidthPaperContent className="section">
          <h4>Delivery date</h4>
          <h2>{moment(pack.deliveryDate).format('MMMM Do YYYY')}</h2>
        </FullWidthPaperContent>

        <FullWidthPaperContent className="section">
          <h4>Your package</h4>
          <BodyText>{getBoxSizeString(pack.product.packSize)}</BodyText>
          <ProductImageView format="thumbnailAndText" items={pack.product.items} />
        </FullWidthPaperContent>

        <FullWidthPaperContent className="section">
          <h4>Your payments</h4>
          <p>
            Any payments made towards this delivery will remain on your account and be
            used before we collect further funds from your nominated payment method.
          </p>
        </FullWidthPaperContent>
      </WidgetContainer>

      <div className="formCta">
        <Button
          fullWidth
          onClick={onSkip}
          dataLayer={{ action: 'Skip a Pack', label: 'Skip a Pack - Confirm' }}
        >
          Skip delivery
        </Button>
        <Button inverse fullWidth type="button" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </StyledOrderSkipView>
  );
};

OrderSkipView.displayName = 'OrderSkipView';

OrderSkipView.propTypes = {
  className: PropTypes.string,
  pack: PropTypes.shape({
    deliveryDate: PropTypes.string,
    product: PropTypes.shape({
      packSize: PropTypes.shape({}),
      items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }),
  }).isRequired,
  onSkip: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

OrderSkipView.defaultProps = {
  className: null,
};

export default OrderSkipView;
